import { authGet } from "@api";
import { AUTH_URL } from "@constants";

import { FetchSsoProviderResponse } from "@pages/settings/types";

export const fetchSsoProvider = (
  deploymentId: string,
  provider_type: string
): Promise<FetchSsoProviderResponse> => {
  const url = `${AUTH_URL}/deployments/${deploymentId}/providers/${provider_type}`;
  return authGet<FetchSsoProviderResponse>(url);
};
